export default __webpack_public_path__ + "static/media/svg-9.41418029.svg";